import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, unref as _unref, mergeProps as _mergeProps, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "relative h-54px flex items-center justify-between pl-15px pr-15px"
};
const _hoisted_2 = {
  class: "absolute right-15px top-[50%] h-54px flex translate-y-[-50%] items-center justify-between"
};
import { propTypes } from '@/utils/propTypes';
import { isNumber } from '@/utils/is';
import { computed, nextTick, ref, unref, useAttrs, useSlots, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Dialog'
  },
  __name: 'Dialog',
  props: {
    modelValue: propTypes.bool.def(false),
    title: propTypes.string.def('Dialog'),
    fullscreen: propTypes.bool.def(true),
    width: propTypes.oneOfType([String, Number]).def('40%'),
    scroll: propTypes.bool.def(false),
    // 是否开启滚动条。如果是的话，按照 maxHeight 设置最大高度
    maxHeight: propTypes.oneOfType([String, Number]).def('400px')
  },
  setup(__props) {
    const slots = useSlots();
    const props = __props;
    const getBindValue = computed(() => {
      const delArr = ['fullscreen', 'title', 'maxHeight', 'appendToBody'];
      const attrs = useAttrs();
      const obj = {
        ...attrs,
        ...props
      };
      for (const key in obj) {
        if (delArr.indexOf(key) !== -1) {
          delete obj[key];
        }
      }
      return obj;
    });
    const isFullscreen = ref(false);
    const toggleFull = () => {
      isFullscreen.value = !unref(isFullscreen);
    };
    const dialogHeight = ref(isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight);
    watch(() => isFullscreen.value, async val => {
      await nextTick();
      if (val) {
        const windowHeight = document.documentElement.offsetHeight;
        dialogHeight.value = `${windowHeight - 55 - 60 - (slots.footer ? 63 : 0)}px`;
      } else {
        dialogHeight.value = isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight;
      }
    }, {
      immediate: true
    });
    const dialogStyle = computed(() => {
      return {
        height: unref(dialogHeight)
      };
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_ElScrollbar = _resolveComponent("ElScrollbar");
      const _component_ElDialog = _resolveComponent("ElDialog");
      return _openBlock(), _createBlock(_component_ElDialog, _mergeProps(getBindValue.value, {
        "close-on-click-modal": true,
        fullscreen: isFullscreen.value,
        width: __props.width,
        "destroy-on-close": "",
        "lock-scroll": "",
        draggable: "",
        class: "com-dialog",
        "show-close": false,
        onClose: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', false))
      }), _createSlots({
        header: _withCtx(({
          close
        }) => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)]), _createElementVNode("div", _hoisted_2, [__props.fullscreen ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "is-hover mr-10px cursor-pointer",
          icon: isFullscreen.value ? 'radix-icons:exit-full-screen' : 'radix-icons:enter-full-screen',
          color: "var(--el-color-info)",
          "hover-color": "var(--el-color-primary)",
          onClick: toggleFull
        }, null, 8, ["icon"])) : _createCommentVNode("", true), _createVNode(_component_Icon, {
          class: "is-hover cursor-pointer",
          icon: "ep:close",
          "hover-color": "var(--el-color-primary)",
          color: "var(--el-color-info)",
          onClick: _withModifiers(close, ["stop"])
        }, null, 8, ["onClick"])])])]),
        default: _withCtx(() => [__props.scroll ? (_openBlock(), _createBlock(_component_ElScrollbar, {
          key: 0,
          style: _normalizeStyle(dialogStyle.value)
        }, {
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
          _: 3
        }, 8, ["style"])) : _renderSlot(_ctx.$slots, "default", {
          key: 1
        })]),
        _: 2
      }, [_unref(slots).footer ? {
        name: "footer",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "footer")]),
        key: "0"
      } : undefined]), 1040, ["fullscreen", "width"]);
    };
  }
});